import React from 'react';
import '../../styles/ui/EmptyState.css';

function EmptyState({ icon = '📭', title, message, actionLabel, onAction, secondaryLabel, onSecondary }) {
  return (
    <div className="empty-state" role="status">
      <div className="empty-state-icon" aria-hidden="true">{icon}</div>
      {title && <h2 className="empty-state-title">{title}</h2>}
      {message && <p className="empty-state-message">{message}</p>}
      <div className="empty-state-actions">
        {actionLabel && onAction && (
          <button type="button" className="empty-state-btn primary" onClick={onAction}>
            {actionLabel}
          </button>
        )}
        {secondaryLabel && onSecondary && (
          <button type="button" className="empty-state-btn secondary" onClick={onSecondary}>
            {secondaryLabel}
          </button>
        )}
      </div>
    </div>
  );
}

export default EmptyState;
